import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconProps } from "@insite/mobius/Icon";
import ArrowUp from "@insite/mobius/Icons/ArrowUp";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import throttle from "lodash/throttle"
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

type Props = {
    containerId: string;
};

export interface ScrollToTopStyles {
    container?: InjectableCss;
    icon?: IconProps;
    btnText?: TypographyProps;
}

export const ScrollToTopButtonStyles: ScrollToTopStyles = {
    container: {
        css: css`
            padding: 10px;
            background: black;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
            border-radius: 20px;
            cursor: pointer;
        `,
    },
    icon: {
        color: "white",
        size: 10,
    },
    btnText: {
        size: 12,
        weight: 400,
        lineHeight: "20px",
        color: "white",
        css: css`
            letter-spacing: 1.25px;
            text-transform: uppercase;
        `,
    },
};

const styles = ScrollToTopButtonStyles;

const ScrollToTopButton = ({ containerId }: Props) => {
    const [showBackToTop, setShowBackToTop] = useState(false);

    const scrollTopTop = () => {
        const element = document.getElementById(containerId);
        if (element) {
            element.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    useEffect(() => {
        const element = document.getElementById(containerId);
        element?.addEventListener("scroll", handleScroll);

        return () => {
            element?.removeEventListener("scroll", handleScroll);
        };
    });

    const handleScroll = throttle(() => {
        const element = document.getElementById(containerId);
        if (!element) {
            return;
        }
        const scrollTop = element.scrollTop;
        const offsetHeight = element.offsetHeight;

        if (scrollTop > offsetHeight) {
            setShowBackToTop(true);
        } else {
            setShowBackToTop(false);
        }
    }, 500);

    if (!showBackToTop) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} onClick={() => scrollTopTop()}>
            <Icon {...styles.icon} src={ArrowUp} />
            <Typography {...styles.btnText}>Top</Typography>
        </StyledWrapper>
    );
};

export default ScrollToTopButton;
